import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PurchaseOrder } from '../models/purchase-order';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  constructor( private http:HttpClient ) { }

  postPurchaseOrder(order:PurchaseOrder) : Promise<PurchaseOrder> {
    return this.http.post<PurchaseOrder>('/api/purchases/order', order)
      .toPromise();
  }

  getReport(date1:Date, date2:Date, type:string = null, ids:string = null, isSap:boolean = false) : Promise<any> {
    if (!type) {
      if(!isSap){
        return this.http.get<any>('/api/purchases/order/report', {params: {date1: date1.toString(), date2:date2.toString()}}).toPromise();
      }else{
        return this.http.get<any>('/api/purchases/order/report', {params: {date1: date1.toString(), date2:date2.toString(), is_sap: 'true'}}).toPromise();
      }
    } else {
      return this.http.get<any>('/api/purchases/order/report', {params: {type, date1: date1.toString(), date2:date2.toString(), ids}}).toPromise();
    }
  }

  authorizeOrder(order:PurchaseOrder) : Promise<PurchaseOrder> {
    return this.http.post<PurchaseOrder>('/api/purchases/order/' + order.id + '/authorize', {})
      .toPromise();
  }

  getOrdersByDates(date1:Date, date2:Date) : Promise<PurchaseOrder[]> {
    return this.http.get<PurchaseOrder[]>('/api/purchases/order', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  getOpenOrders() : Promise<PurchaseOrder[]> {
    return this.http.get<PurchaseOrder[]>('/api/purchases/order/open')
      .toPromise();
  }

  getOrder(order_id) : Promise<PurchaseOrder> {
    return this.http.get<PurchaseOrder>('/api/purchases/order/' + order_id)
      .toPromise();
  }

  deleteOrder(params) : Promise<any> {
    return this.http.get<any>('/api/purchases/order/delete', {params})
      .toPromise();
  }
}
